import { platform } from "@/utils/platform";
import React from "react";
import styles from "./index.module.less";

interface TopBgBoxProps {
    rankName?: string;
    statusBarHeight: number;
    isTabSticky: boolean;
    style?: React.CSSProperties;
}

/**
 * 榜单详情页顶部背景区域组件
 * 包含右上角按钮、吸顶导航栏、背景图、榜单头部等
 */
const TopBgBox: React.FC<TopBgBoxProps> = ({
    rankName="热卖榜单",
    statusBarHeight =0,
    isTabSticky = false,
    style
}) => {
  return (
    <div className={styles.topBgBoxNoSticky + " " + (platform.isApp ? styles.topBgBoxNoStickyApp : styles.topBgBoxNoStickyH5)} style={style}>
      {/* 榜单头部组件（两侧枝条+中间榜单名称） - 始终显示 */}
      <div className={styles.mainHeader}>
        <img
          src="https://akim-oss.aikucun.com/1e629a0b6d39e51e59273cfe7846e48bf7236498_1742200887633_61.png"
          alt="Success"
          className={styles.img}
        />
        <div className={styles.mainTitle}>
          {rankName}
        </div>
        <img
          src="https://akim-oss.aikucun.com/5c7f0bf02ad95b8377d7096775c4d17b228ec732_1742200882836_6.png"
          alt="Success"
          className={styles.img}
        />
      </div>
      
      {/* 热销榜，根据近3日销量加权排序 */}
      <div className={styles.mainCenterView}>
        <div className={styles.mainCenter}>真实数据 官方背书</div>
      </div>
      
      <div className={styles.tips}>数据实时更新，请以榜单页面排名为准</div>
    </div>
  );
};

export default TopBgBox;